import { informationStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { css } from "styled-components";


informationStyles.invoiceInformationGridContainer = {
    css: css`
        margin-top: 30px;
    `
}